(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kima-rut-gate"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.getElementById('KimaRutGate');
    if (!dialog || dialog.dataset.initialized === 'true') return;

    dialog.dataset.initialized = 'true';
    document.documentElement.classList.add('kima-rut-market-cl');

    const form = document.getElementById('KimaRutGateForm');
    const input = document.getElementById('KimaRutInput');
    const error = document.getElementById('KimaRutError');
    const submit = form.querySelector('.kima-rut-gate__submit');
    const submitLabel = form.querySelector('[data-kima-rut-submit-label]');
    const savingLabel = form.querySelector('[data-kima-rut-saving-label]');
    const checkoutSelector = '#CartDrawer-Checkout, button[name="checkout"], input[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]';
    let checkoutTarget = null;
    let bypassGate = false;
    let openedAt = 0;
    let invalidAttempts = 0;
    let checkoutSurface = 'unknown';
    let checkoutContinuationStarted = false;

    const identifyCheckoutSurface = (target) => {
      if (!target) return 'unknown';
      if (target.id === 'CartDrawer-Checkout' || target.closest('#CartDrawer')) return 'cart_drawer';
      if (target.closest('form[action*="/cart"]')) return 'cart_page';
      return target.tagName === 'A' ? 'checkout_link' : 'checkout_button';
    };

    const getTrackingData = (details = {}) => ({
      market: 'CL',
      locale: document.documentElement.lang || 'es',
      device_type: window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop',
      checkout_surface: checkoutSurface,
      page_path: window.location.pathname,
      elapsed_ms: openedAt ? Math.max(0, Date.now() - openedAt) : 0,
      invalid_attempts: invalidAttempts,
      ...details
    });

    const publishTracking = (eventName, details = {}) => {
      const eventData = getTrackingData(details);
      dialog.dataset.lastAnalyticsEvent = eventName;

      try {
        const publishResult = window.Shopify?.analytics?.publish?.(eventName, eventData);
        if (publishResult && typeof publishResult.catch === 'function') publishResult.catch(() => {});
      } catch {}

      try {
        if (typeof window.gtag === 'function') {
          window.gtag('event', eventName, eventData);
        } else if (Array.isArray(window.dataLayer)) {
          window.dataLayer.push({ event: eventName, ...eventData });
        }
      } catch {}

      try {
        if (typeof window.klaviyo?.track === 'function') {
          const klaviyoResult = window.klaviyo.track(eventName, eventData);
          if (klaviyoResult && typeof klaviyoResult.catch === 'function') klaviyoResult.catch(() => {});
        } else if (Array.isArray(window._learnq)) {
          window._learnq.push(['track', eventName, eventData]);
        }
      } catch {}
    };

    const cleanRut = (value) => value.replace(/[.\s-]/g, '').toUpperCase();

    const isValidRut = (value) => {
      const clean = cleanRut(value);
      if (!/^\d{7,8}[0-9K]$/.test(clean)) return false;

      const body = clean.slice(0, -1);
      if (/^0+$/.test(body)) return false;

      let sum = 0;
      let multiplier = 2;

      for (let index = body.length - 1; index >= 0; index -= 1) {
        sum += Number(body[index]) * multiplier;
        multiplier = multiplier === 7 ? 2 : multiplier + 1;
      }

      const remainder = 11 - (sum % 11);
      const expected = remainder === 11 ? '0' : remainder === 10 ? 'K' : String(remainder);
      return clean.slice(-1) === expected;
    };

    const formatRut = (value) => {
      const clean = cleanRut(value);
      const body = clean.slice(0, -1);
      const verifier = clean.slice(-1);
      return `${body.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}-${verifier}`;
    };

    const setError = (message) => {
      error.textContent = message;
      error.hidden = false;
      input.setAttribute('aria-invalid', 'true');
    };

    const clearError = () => {
      error.textContent = '';
      error.hidden = true;
      input.removeAttribute('aria-invalid');
    };

    const setBusy = (busy) => {
      submit.disabled = busy;
      input.disabled = busy;
      submitLabel.hidden = busy;
      savingLabel.hidden = !busy;
    };

    const openGate = (target) => {
      checkoutTarget = target;
      checkoutSurface = identifyCheckoutSurface(target);
      openedAt = Date.now();
      invalidAttempts = 0;
      checkoutContinuationStarted = false;
      form.reset();
      clearError();
      setBusy(false);
      document.body.classList.add('kima-rut-gate-open');
      dialog.showModal();
      publishTracking('kima_rut_popup_view');
      window.requestAnimationFrame(() => input.focus());
    };

    const closeGate = () => {
      if (dialog.open) dialog.close();
    };

    const findCheckoutTarget = (path) => {
      for (const node of path) {
        if (node instanceof Element && node.matches(checkoutSelector)) return node;
      }
      return null;
    };

    const continueToCheckout = () => {
      const target = checkoutTarget;
      checkoutTarget = null;
      bypassGate = true;

      if (target && target.isConnected && typeof target.click === 'function') {
        target.click();
      } else {
        const root = window.Shopify?.routes?.root || '/';
        window.location.assign(`${root}checkout`);
      }

      window.setTimeout(() => {
        bypassGate = false;
      }, 1500);
    };

    document.addEventListener('click', (event) => {
      if (bypassGate || dialog.contains(event.target)) return;

      const target = findCheckoutTarget(event.composedPath());
      if (!target || target.matches(':disabled')) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      openGate(target);
    }, true);

    document.addEventListener('submit', (event) => {
      if (bypassGate || dialog.contains(event.target)) return;

      const target = event.submitter && event.submitter.matches(checkoutSelector) ? event.submitter : null;
      if (!target) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      openGate(target);
    }, true);

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      clearError();

      if (!isValidRut(input.value)) {
        invalidAttempts += 1;
        publishTracking('kima_rut_validation_error', { error_type: 'invalid_rut' });
        setError(dialog.dataset.invalidMessage);
        input.focus();
        return;
      }

      const formattedRut = formatRut(input.value);
      input.value = formattedRut;
      setBusy(true);

      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/update.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ attributes: { RUT: formattedRut } })
        });

        if (!response.ok) throw new Error('cart_update_failed');
        await response.json();
        publishTracking('kima_rut_save_success');
        checkoutContinuationStarted = true;
        publishTracking('kima_rut_checkout_continue');
        closeGate();
        continueToCheckout();
      } catch (requestError) {
        publishTracking('kima_rut_save_error', { error_type: 'cart_update_failed' });
        setBusy(false);
        setError(dialog.dataset.saveErrorMessage);
      }
    });

    input.addEventListener('input', clearError);
    input.addEventListener('blur', () => {
      if (isValidRut(input.value)) input.value = formatRut(input.value);
    });

    dialog.querySelector('.kima-rut-gate__close').addEventListener('click', () => {
      publishTracking('kima_rut_popup_close', { close_method: 'button' });
      closeGate();
    });

    dialog.querySelector('.kima-rut-gate__back').addEventListener('click', () => {
      publishTracking('kima_rut_back_to_cart');
      closeGate();
    });

    dialog.addEventListener('cancel', () => {
      publishTracking('kima_rut_popup_close', { close_method: 'escape' });
    });

    dialog.addEventListener('close', () => {
      document.body.classList.remove('kima-rut-gate-open');
      clearError();
      setBusy(false);
      checkoutTarget = null;
      openedAt = 0;
      invalidAttempts = 0;
      checkoutSurface = 'unknown';
    });

    window.addEventListener('pagehide', () => {
      if (dialog.open && !checkoutContinuationStarted) {
        publishTracking('kima_rut_page_exit', { exit_reason: 'navigation' });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
